import { render, staticRenderFns } from "./DetailBlock1.vue?vue&type=template&id=4099906a&scoped=true"
import script from "./DetailBlock1.vue?vue&type=script&lang=js"
export * from "./DetailBlock1.vue?vue&type=script&lang=js"
import style0 from "./DetailBlock1.vue?vue&type=style&index=0&id=4099906a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4099906a",
  null
  
)

export default component.exports